module.exports = __webpack_public_path__ + "media/yupchat-notification.914a2c0c.ogg";